export default __webpack_public_path__ + "static/image16-20f59fc8100d576aa804f5f2c1a242fe.jpg";